import { action } from 'easy-peasy';
import { IActionDeleteReadings } from '../types';

const deleteReadings: IActionDeleteReadings = action((state, ids) => {
  state.items = state.items.filter(item => !ids.includes(item.id));
});

export default deleteReadings;
